import React, { Component } from 'react';
import classNames from 'classnames';

interface ModalProps {
  isOpen: boolean;
  full?: boolean;
  header?: string;
  showCloseButton?: boolean;
  closeOnEscapse?: boolean;
  onRequestClose?: (target: 'overlay' | 'button' | 'keyboard') => void;
}

export class Modal extends Component<ModalProps> {
  private onKeypressHandler = (event: KeyboardEvent) => {
    if (!this.props.closeOnEscapse) {
      return;
    }

    if (!this.props.isOpen) {
      return;
    }

    const ESCAPE_CODE = 27;
    if (event.which !== ESCAPE_CODE) {
      return;
    }

    if (typeof this.props.onRequestClose === 'function') {
      this.props.onRequestClose('keyboard');
    }
  };

  static defaultProps = {
    isOpen: false,
    full: false,
    closeOnEscapse: true,
    onRequestClose: () => {},
    showCloseButton: true,
  };

  componentDidMount() {
    document.addEventListener('keydown', this.onKeypressHandler);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.onKeypressHandler);
  }

  render() {
    const {
      isOpen,
      showCloseButton,
      full,
      header,
      onRequestClose = () => {},
      children,
    } = this.props;

    if (!isOpen) {
      return null;
    }

    return (
      <div className={classNames('mx-modal-container', { ['mx-modal-full']: full })}>
        <input type="checkbox" className="mx-modal-checkbox" checked readOnly />
        <i className="mx-modal-overlay" onClick={() => onRequestClose('overlay')} />

        <div className="mx-modal-content">
          {showCloseButton && (
            <span className="mx-modal-close" onClick={() => onRequestClose('button')} />
          )}

          {header && (
            <div className="mx-modal-header">
              <h2>{header}</h2>
            </div>
          )}

          {children}
        </div>
      </div>
    );
  }
}
